import { useRef } from "react";
import { useParams } from "next/navigation";

import Slider, { Settings } from "react-slick";

import { APP_SIZE } from "@styles/variables";
import { usePreventVerticalScroll } from "@logics/hooks/usePreventVerticalScroll";
import { useFetchEventDetailQuery } from "@domains/event/network/eventQueries";

import * as S from "./ImageSliderSection.style";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const sliderSettings: Settings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  touchThreshold: 100,
  adaptiveHeight: true,
  cssEase: "linear",
  appendDots: (dots) => (
    <S.CustomSlickDots>
      <S.DotsList> {dots} </S.DotsList>
    </S.CustomSlickDots>
  ),
};

const ImageSliderSection = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const param = useParams<{ eventId?: string }>();

  const { data: eventDetail } = useFetchEventDetailQuery(param?.eventId);

  usePreventVerticalScroll<HTMLDivElement>(containerRef);

  return (
    <S.ImageSliderWrapper ref={containerRef}>
      <Slider
        {...sliderSettings}
        dots={(eventDetail?.imageUrlList?.length || 0) > 1}
      >
        {(eventDetail?.imageUrlList as string[])?.map((imageUrl) => (
          <S.ImageWrapper key={imageUrl}>
            <S.DetailImage
              src={imageUrl || "/assets/detail-test-image.png"}
              alt="detail-main"
              width={0}
              height={0}
              sizes={`${APP_SIZE.MAX_WIDTH}px`}
            />
            <S.GradientOverlay />
          </S.ImageWrapper>
        ))}
      </Slider>
    </S.ImageSliderWrapper>
  );
};

export default ImageSliderSection;
